import { forwardRef } from 'react';

import { Colors } from '@sternum/web/components/theme/constants';

import { IconProps } from '../icons.types';

import { SpinnerIconStyled } from './SpinnerIcon.styles';

export interface SpinnerIconProps extends Omit<IconProps, 'color'> {
  color1?: string;
  color2?: string;
}

export const SpinnerIcon = forwardRef<SVGSVGElement, SpinnerIconProps>(function SpinnerIcon(
  { color1 = Colors.White, color2 = Colors.BrandBlue, height = 20, width = 20, hasCursorPointer, ...props },
  ref,
) {
  return (
    <SpinnerIconStyled
      ref={ref}
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-has-cursor-pointer={hasCursorPointer}
      aria-label="loading spinner"
      {...props}
    >
      <path
        d="M20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10ZM1.5 10C1.5 14.6944 5.30558 18.5 10 18.5C14.6944 18.5 18.5 14.6944 18.5 10C18.5 5.30558 14.6944 1.5 10 1.5C5.30558 1.5 1.5 5.30558 1.5 10Z"
        fill={color1}
      />
      <path
        d="M10 0.75C10 0.335786 10.3363 -0.00292585 10.7493 0.0281107C12.1997 0.137089 13.612 0.561437 14.8862 1.27504C16.379 2.11107 17.6324 3.31615 18.5264 4.77501C19.4204 6.23388 19.9251 7.89772 19.9923 9.6074C20.0595 11.3171 19.6868 13.0154 18.9101 14.5399C18.1333 16.0644 16.9783 17.3641 15.5557 18.3147C14.1331 19.2653 12.4903 19.8349 10.7846 19.9692C9.07887 20.1034 7.36723 19.7978 5.8134 19.0814C4.48711 18.47 3.31367 17.5768 2.37301 16.4675C2.10512 16.1516 2.18149 15.6805 2.51659 15.437V15.437C2.8517 15.1935 3.31833 15.2704 3.59039 15.5827C4.37727 16.4862 5.34825 17.2153 6.44139 17.7192C7.76215 18.3281 9.21704 18.5879 10.6669 18.4738C12.1168 18.3597 13.5131 17.8755 14.7223 17.0675C15.9316 16.2595 16.9133 15.1548 17.5736 13.8589C18.2338 12.5631 18.5505 11.1195 18.4934 9.66629C18.4363 8.21307 18.0073 6.7988 17.2474 5.55876C16.4875 4.31873 15.4222 3.29441 14.1533 2.58378C13.103 1.99563 11.9425 1.63864 10.749 1.53307C10.3364 1.49656 10 1.16421 10 0.75V0.75Z"
        fill={color2}
      />
    </SpinnerIconStyled>
  );
});

export const SpinnerIconGray = { ...SpinnerIcon } as typeof SpinnerIcon;

SpinnerIconGray.defaultProps = {
  color1: Colors.White,
  color2: Colors.GreyDarker,
};
